export const transactionRows = [
  {
    id: 0,
    date: 'Sep 2, 2024',
    type: 'deposit',
    currency: {
      coinImg: '/assets/profile/usdt.png',
      coinName: 'USDT',
    },
    amount: 200,
  },
  {
    id: 1,
    date: 'Sep 2, 2024',
    type: 'deposit',
    currency: {
      coinImg: '/assets/profile/usdt.png',
      coinName: 'USDT',
    },
    amount: 200,
  },
  {
    id: 2,
    date: 'Sep 2, 2024',
    type: 'withdraw',
    currency: {
      coinImg: '/assets/profile/usdt.png',
      coinName: 'USDT',
    },
    amount: -200,
  },
  {
    id: 3,
    date: 'Sep 2, 2024',
    type: 'deposit',
    currency: {
      coinImg: '/assets/profile/usdt.png',
      coinName: 'USDT',
    },
    amount: 200,
  },
  {
    id: 4,
    date: 'Sep 2, 2024',
    type: 'deposit',
    currency: {
      coinImg: '/assets/profile/usdt.png',
      coinName: 'USDT',
    },
    amount: 200,
  },
  {
    id: 5,
    date: 'Sep 2, 2024',
    type: 'deposit',
    currency: {
      coinImg: '/assets/profile/usdt.png',
      coinName: 'USDT',
    },
    amount: 200,
  },
  {
    id: 6,
    date: 'Sep 2, 2024',
    type: 'withdraw',
    currency: {
      coinImg: '/assets/profile/usdt.png',
      coinName: 'USDT',
    },
    amount: -200,
  },
]
